module.exports = {
  siteMetadata: {
    title: 'Venture capital for Berlin | IBB Ventures',
    shortName: 'IBB Ventures',
    description: 'We finance successful Berlin start-ups!',
    author: 'hy.am studios',
    siteUrl: 'https://www.example.com',
  },
  cms: {
    prismicRepoName: 'ibbventures',
    defaultLang: 'de-de',
    langs: ['en-gb', 'de-de'],
  },
  langNames: {
    en: 'English',
    de: 'Deutsch',
  },
  themeColor: '#000000',
  backgroundColor: '#ffffff',
}
